import { render, staticRenderFns } from "./retificacaoArqFederal.vue?vue&type=template&id=17d515e8&scoped=true&"
import script from "./retificacaoArqFederal.vue?vue&type=script&lang=js&"
export * from "./retificacaoArqFederal.vue?vue&type=script&lang=js&"
import style0 from "./retificacaoArqFederal.vue?vue&type=style&index=0&id=17d515e8&lang=scss&scoped=true&"
import style1 from "./retificacaoArqFederal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d515e8",
  null
  
)

export default component.exports